import LoginPage from "./auth/login";
import DashBoardPage from "./dashBoard";
import ManageCustomers from "./users";
import ForgotPasswordPage from "./auth/forgotPassword";
import VerifyOtp from "./auth/otp";
import Analytics from "./analytics";
import ResetPassword from "./auth/resetPassword";
import Profile from "./profile";
import ManageCms from "./manageCms";
import ManageNotifications from "./manageNotification";
import AddNotification from "./manageNotification/add";
import RecievedNotifications from "./manageNotification/receivedNotification";
import ChangePassword from "./auth/changePassword";
import ManageOrders from "./CustomerOrder";
import CustomerOrderDetails from "./CustomerOrder/details";
import { ChatDetails } from "../features";
import AddCategory from "./categories/add";
import CategoryDetails from "./categories/details";
import ManageCategory from "./categories";
import ManageRevenue from "./revenue";
import AddBanners from "./banners/add";
import BannersDetails from "./banners/details";
import ManageBanners from "./banners";
import ManageListing from "./manageListing";
import WishlistPropertyDetails from "./users/details/wishlistDetails";
import userChatInboxDetails from "./users/details/chatDetails";
import UserEmailInboxDetails from "./users/details/emailDetails";
import ManageEnqeries from "./manageEnqueries";
import ProductDetails from "./ManageProducts/details";
import AddProduct from "./ManageProducts/add";
import ManageSubAdmin from "./ManageSubAdmin";
import AddSubAdmin from "./ManageSubAdmin/add";
import ManageSupport from "./Support";
import ManageChats from "./ManageChats";
import ChatInbox from "./ManageChats/details";
import ManagePayments from "./ManagePayment";
import PaymentDetails from "./ManagePayment/details";
import EditSubCategory from "./categories/addSubCategory";
import AddCategoryMain from "./categories/add";
import addSubCategory from "./categories/addSubCategory";
import AddSettings from "./settings";
import AddVendors from "./ManageAgents/add";
import AgentDetail from "./ManageAgents/details";
import ManageAgents from "./ManageAgents";
import ManageQuotes from "./ManageQuotes";
import ManageReturnExchange from "./ManageReturnExchange";
import QuotesChatDetails from "./ManageQuotes/chatInbox";
import ManageProduct from "./ManageProducts";
import ManageRefunds from "./manageRefunds";
import AddCommision from "./settings/add";
import ManageDiscount from "./manageDiscount";
import AddDiscount from "./manageDiscount/add";
import DiscountDetails from "./manageDiscount/details";
import PrivacyPolicy from "./privacyPolicy";
import ReturnExchangeDetails from "./ManageReturnExchange/details";
import ExchangeRate from "./ExchangeRate";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  AddCategory,
  ManageCategory,
  LoginPage,
  DashBoardPage,
  ManageCustomers,
  ForgotPasswordPage,
  VerifyOtp,
  Analytics,
  ResetPassword,
  Profile,
  ManageCms,
  ManageNotifications,
  AddNotification,
  RecievedNotifications,
  ChangePassword,
  ChatDetails,
  CategoryDetails,
  CustomerOrderDetails,
  ManageRevenue,
  AddBanners,
  BannersDetails,
  ManageBanners,
  WishlistPropertyDetails,
  userChatInboxDetails,
  UserEmailInboxDetails,
  ManageEnqeries,
  ManageOrders,
  ProductDetails,
  AddProduct,
  ManageSubAdmin,
  AddSubAdmin,
  ManageSupport,
  ManageChats,
  ChatInbox,
  ManagePayments,
  PaymentDetails,
  EditSubCategory,
  AddCategoryMain,
  addSubCategory,
  AddSettings,
  AddVendors,
  AgentDetail,
  ManageAgents,
  ManageQuotes,
  ManageReturnExchange,
  QuotesChatDetails,
  ManageProduct,
  ManageRefunds,
  AddCommision,
  ManageDiscount,
  AddDiscount,
  DiscountDetails,
  PrivacyPolicy,
  ReturnExchangeDetails,
  ExchangeRate,
};
